export default __webpack_public_path__ + "static/media/Behance.c4128d5d.svg";